export default {

  /**
   * Find the percentage difference between two numbers
   *
   * @param oldValue
   * @param newValue
   * @param decimals
   * @returns {*|string}
   */
  calculatePercentageDifference(oldValue, newValue, decimals) {
    const difference = newValue - oldValue;
    const percentage = (difference / oldValue) * 100;
    return this.roundNumber(percentage, decimals);
  },

  /**
   * Find the difference by percentage
   *
   * @param percentage
   * @param value
   * @param decimals
   * @returns {number}
   */
  calculateDifferenceByPercentage(percentage, value, decimals) {
    const newPercentage = percentage / 100;
    return this.roundNumber((value * newPercentage), decimals);
  },

  /**
   * Add percentage
   *
   * @param percentage
   * @param value
   * @returns {*}
   */
  addPercentage(percentage, value, decimals) {
    const newPercentage = percentage / 100;
    return this.roundNumber(value / (1 - newPercentage), decimals);
  },

  /**
   * Find percentage between two numbers
   *
   * @param oldValue
   * @param newValue
   * @param decimals
   * @returns {*|string}
   */
  calculatePercentage(oldValue, newValue, decimals) {
    const percentage = (newValue / oldValue) * 100;
    return this.roundNumber(percentage, decimals);
  },

  /**
   * Round numbers with decimals
   *
   * @param number
   * @param decimals
   * @returns {string}
   */
  roundNumber(number, decimals) {
    return Number(number).toFixed(decimals);
  },
};



// WEBPACK FOOTER //
// ./src/utils/calculator.js